import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';

import { PrimecalendarService } from './../primecalendar.service';
import { LoaderEvent } from './../../shared/message.event';
import { UtilityFunctions } from '../../shared/utility-functions';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';

@Component({
	selector: 'view-invoice',
	templateUrl: './view-invoice.component.html',
	styleUrls: ['./view-invoice.component.css'],
	providers: [PrimecalendarService, LoaderEvent],
	exportAs: 'viewInvoice'
})
export class ViewInvoice implements OnInit {
	private invoice = {
		invoiceId: '',
		activityName: '',
		date: '',
		time: '',
		attendeesCount: '',
		GSTValue: '',
		totalGST: '',
		totalAmount: '',
		bookingId: '',
		userId: '',
		vendorId: ''
	};
	private bookingId;
	private userId;
	private vendorId;
	private popUpMessage = '';
	@Output() notify = new EventEmitter<boolean>();
	@Output() markPaymentDone = new EventEmitter<string>();
	@ViewChild('childModal') childModal: ModalDirective;
	private utilityFunctions = new UtilityFunctions();
	constructor(private primecalendarService: PrimecalendarService, private loaderEvent: LoaderEvent) { }
	ngOnInit() {
	}
	// We will use passded value for payment at vendor
	public showChildModal(invoice): void {
		this.invoice = invoice;
		this.childModal.config.backdrop = false;
		this.childModal.config.keyboard = false;
		this.utilityFunctions.setBackGroundBlack();
		this.childModal.show();
	}

	public hideChildModal(): void {
		this.notify.emit(true);
		this.utilityFunctions.removeBackGroundBlack();
		this.childModal.hide();
	}

	makePayment() {
		let that = this;
		let paymentObj = {
			'bookingId': this.invoice.bookingId,
			'_id': this.invoice.userId,
			'vendorId': this.invoice.vendorId,
			payAt: 'vendor'
		};
		this.loaderEvent.fire(false);
		this.primecalendarService.makePayment(paymentObj).then((result: any) => {
			this.loaderEvent.fire(true);
			if (result.status === 'SUCCESS') {
				this.childModal.hide();
				this.markPaymentDone.emit(result.message);
			} else {
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/view-invoice/view-invoice.component.ts